/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPaymentsV1WireState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PAYMENTS_V1_WIRE_STATE_ENTITY_NAME = 'ixc.payments.v1.Wire';
export const ixcPaymentsV1WireStateEntity = new schema.Entity<IxcPaymentsV1WireState>(IXC_PAYMENTS_V1_WIRE_STATE_ENTITY_NAME, {}, { idAttribute: 'wireId' });

